<template>
  <home-layout>
    <div class="container-fluid  bg_principal" >
      <div class="container-fluid bg">
        <div class="container-fluid">
          <div  v-if="!showData" class="row">
            <div class="bg-white form_login col-md-5 col-lg-4 col-xl-4 center-block">
              <p class="txt-invertir">Contáctanos</p>
              <form @submit.prevent="validateForm" id="frmlogin" name="frmlogin" class="needs-validation text-center" novalidate>
                <div class="form-group mt-3">
                  <input type="name" v-model="loginForm.name" class="form-control input-acces" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre" required>
                </div>
                <div class="form-group mt-3">
                  <input type="email" v-model="loginForm.email" class="form-control input-acces" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email address" required>
                </div>
                <div v-if="showError" class="txt_error_frm">{{messageErrorLogin}}</div>
                <button type="submit" class="btn-access">Enviar</button>
              </form>
              <p class="txt-aprende">Aprende m&aacute;s <a href="/blog" class="txt-aprende-aqui">aquí</a> </p>
            </div>
          </div>
          <div v-if="showData" class="row">
            <div class="bg-white form_login col-md-5 col-lg-4 col-xl-4 center-block">
              <p class="txt-contact">Gracias por escribirnos, pronto nos coumunicaremos contigo</p>
              
              <p class="txt-aprende">Aprende m&aacute;s <a href="/blog" class="txt-aprende-aqui">aquí</a> </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <header-info :section=true ></header-info>
    <footer-info :section=false></footer-info>
  </home-layout>
  
</template>

<script>



import imgBackground from "@/assets/access/background.png";
import {saveUser} from '@/services/users'
import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import "@/assets/access.css";

export default {
  name: 'Contact',
  props: {

  },
  data () {
    
    return {
      imgBackground:imgBackground,
      access:true,
      messageErrorLogin:'',
      showError:false,
      loginForm: {
        name:'',
        email:''
      }
    }
  }
  ,
  created () {
    document.body.classList.add("bg_principal");
  },
  mounted () {
    
  },
  components: {
    HeaderInfo,
    HomeLayout,
    FooterInfo
  },
  methods: {
    validateForm (event) {
      this.isValid = true
      const form = document.getElementById('frmlogin')
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        form.classList.add('was-validated')
        this.isValid=false
      }

      if (this.isValid) {
        saveUser(this.loginForm).then((response) => {
                        
            if (response.error) {
              this.showData = true
              this.showError = true
              this.messageErrorLogin = response.error.message
          
            } else {
              this.showData = true
              this.showError = true
            }
      })
      }
      else {
        console.log("NO valido")
      }

    }
  }
}

</script>
